import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CategoryView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerCatalog } from "@/lib/query/core/invalidation";

type UpdateCategoryInput = {
  storeSlug: string;
  categoryId: string;
  nameAr: string;
  nameEn: string | null;
  sortOrder?: number;
};

export function useUpdateCategoryMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: UpdateCategoryInput) => {
      const { storeSlug, categoryId, ...body } = input;
      void storeSlug;
      return apiJsonClient<CategoryView>(endpoints.seller.categoryById(categoryId), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
    },
    onSuccess: async (_data, variables) => {
      await invalidateSellerCatalog(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
